import React, { useState } from "react";
import { message, Space } from "antd";
import { PlusOutlined, SyncOutlined } from "@ant-design/icons";
import AllPatientTable from "./AllPatientTable";
import AddPatientModal from "../AddPatientModal";
import { syncBillsApi } from "../../../services/receptionist.services";
import { UiButton, UiDataTable } from "../../ui";
import styles from "./AllPatient.module.css";

const AllPatient = ({
  data,
  refresh,
  setPage,
  setSearchQuery,
  page,
  searchQuery,
  loading,
}) => {
  const [openAddPatient, setOpenAddPatient] = useState(false);

  const onContactSearch = (value) => {
    setSearchQuery(value?.target?.value);
  };

  const onSync = () => {
    syncBillsApi()
      .then(() => {
        refresh();
      })
      .catch((err) => message.error(err?.response?.data?.message));
  };

  return (
    <UiDataTable
      showHeader={false}
      shellClassName="reception-patient-list-shell"
      onSearch={onContactSearch}
      searchValue={searchQuery || ""}
      searchPlaceholder="Search for patient"
      toolbarTrailing={
        <Space wrap className={styles.allPatientToolbarActions}>
          <UiButton
            onClick={() => setOpenAddPatient(true)}
            variant="primary"
            size="md"
          >
            <PlusOutlined /> New Patient
          </UiButton>
          <UiButton
            onClick={onSync}
            variant="ghost"
            size="md"
            className={styles.allPatientSyncBtn}
          >
            <SyncOutlined /> Sync Balance
          </UiButton>
        </Space>
      }
    >
      <AllPatientTable
        data={data}
        refresh={refresh}
        setPage={setPage}
        page={page}
        loading={loading}
      />
      {openAddPatient && (
        <AddPatientModal
          open={openAddPatient}
          setOpen={setOpenAddPatient}
          refresh={refresh}
        />
      )}
    </UiDataTable>
  );
};

export default AllPatient;
